import { PartialTranslation } from '../translations';

export const jv: PartialTranslation = {
  newChat: 'Obrolan Anyar',
  search: 'Goleki',
  user: 'Pangguna',
  settings: 'Pangaturan',
  language: 'Basa',
  getHelp: 'Njaluk Tulung',
  viewAllPlans: 'Deleng Kabeh Rencana',
  learnMore: 'Sinau Luwih',
  logOut: 'Metu',
  chooseLanguage: 'Pilih Basa',
  chooseYourPreferredLanguage: 'Pilih basa sing koktresnani',
  searchLanguages: 'Goleki basa...',
  autoDetect: 'Deteksi Otomatis',
  noLanguagesFound: 'Ora ana basa sing ditemokake',
  askAnything: 'Takon apa wae',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Pribadi',
  freePlan: 'Rencana gratis',
  current: 'Saiki',
  close: 'Tutup',
  archive: 'Arsip',
  delete: 'Busak',
  confirmDelete: 'Apa sampeyan yakin arep mbusak obrolan iki?',
  confirmArchive: 'Apa sampeyan yakin arep ngarsip obrolan iki?',
  deleteCannotUndo: 'Tumindak iki ora bisa dibatalake.',
  archiveCanFind: 'Sampeyan bisa nemokake ing daftar arsip sawise ngarsip.',
  
  // 资源面板
  resources: 'Sumber Daya',
  addResource: 'Tambah Sumber Daya',
  deleteResource: 'Busak Sumber Daya',
  noMatchingResourcesFound: 'Ora ana sumber daya sing cocog',
  noResourcesAvailable: 'Ora ana sumber daya sing kasedhiya',
  hideResources: 'Dhelikake Sumber Daya',
  showResources: 'Tuduhake Sumber Daya',
  
  // 聊天输入框
  typeMessage: 'Ketik pesen...',
  thinkingOptions: 'Pilihan mikir',
  deleteFile: 'Busak berkas',
  clearSelection: 'Resiki pilihan',
  addAttachment: 'Tambah Lampiran',
  sendMessage: 'Kirim Pesen',
  
  // 思考模式选项
  deepInsight: 'Wawasan Jero · Analisis Permukaan',
  deepInsightDesc: 'Pangerten cepet babagan poin kunci',
  deepExploration: 'Eksplorasi Jero · Analisis Lengkap',
  deepExplorationDesc: 'Riset jero multi-dimensi',
  deepDeconstruction: 'Dekonstruksi Jero · Argumentasi Sistematis',
  deepDeconstructionDesc: 'Analisis progresif lapis demi lapis',
  
  // 写作模式选项
  contractReview: 'Review Kontrak · Identifikasi Risiko',
  contractReviewDesc: 'Analisis klausul lan pemeriksaan kepatuhan',
  textPolish: 'Polish Teks · Ekspresi Profesional',
  textPolishDesc: 'Optimisasi basa lan penyesuaian struktur',
  legalDocuments: 'Dokumen Hukum · Penyusunan Standar',
  legalDocumentsDesc: 'Nulis dokumen hukum profesional',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Mlebu',
  register: 'Ndaftar',
  welcomeBack: 'Sugeng rawuh ing LawHelper',
  loginSubtitle: 'Asisten Riset Hukum AI sampeyan',
  continueWithGoogle: 'Terusake karo Google',
  continueWithMicrosoft: 'Terusake karo Microsoft',
  continueWithWeChat: 'Terusake karo WeChat',
  orContinueWith: 'utawa terusake karo',
  emailTab: 'Email',
  phoneTab: 'Telpon',
  emailPlaceholder: 'Lebokake email sampeyan',
  phonePlaceholder: 'Lebokake nomer telpon',
  codePlaceholder: 'Lebokake kode 6 digit',
  sending: 'Ngirim...',
  verifying: 'Verifikasi...',
  verify: 'Verifikasi',
  sendMagicLink: 'Kirim link ajaib',
  getVerificationCode: 'Entuk kode',
  resendCode: 'Kirim maneh kode',
  resendIn: 'Kirim maneh',
  magicLinkSent: 'Link ajaib wis dikirim menyang email sampeyan',
  magicLinkHint: 'Kita bakal ngirim link aman menyang email sampeyan',
  otpSent: 'Kode verifikasi wis dikirim',
  agreeToTerms: 'Kanthi nerusake, sampeyan setuju',
  privacyPolicy: 'Kabijakan Privasi',
  termsOfService: 'Syarat Layanan',
  and: 'lan',
  privacyTitle: 'Privasi sampeyan penting',
  privacyIntro: 'Kita nggunakake cookie kanggo pengalaman paling apik.',
  essentialCookies: 'Cookie penting',
  essentialDesc: 'Dibutuhake supaya situs web bisa mlaku',
  analyticsCookies: 'Cookie analitik',
  analyticsDesc: 'Mbantu ningkatake layanan',
  marketingCookies: 'Cookie marketing',
  marketingDesc: 'Digunakake kanggo konten pribadi',
  acceptAll: 'Tampa kabeh',
  essentialOnly: 'Mung penting',
  customize: 'Kustomisasi',
  savePreferences: 'Simpen preferensi',
  back: 'Bali',
  readPrivacyPolicy: 'Waca kabijakan privasi',
  cookiePolicy: 'Kabijakan Cookie',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'Tinjauan AI',
  aiDraft: 'Draf AI',
  smartAssistant: 'Cithakan',

  // 知识库搜索
  enableKnowledgeSearch: 'Aktifake telusuran',
  knowledgeSearchDesc: 'AI nggoleki ing dokumen panjenengan',
  clickToDisable: 'Pateni',
  clickToEnable: 'Aktifake',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Close Resources Panel',
  uploading: 'Uploading %{fileName}...',
  processing: 'Processing %{fileName}...',
  uploadSuccess: '✓ %{fileName} uploaded successfully',
  uploadError: '✗ Upload failed: %{error}',
  quickAnswer: 'Wangsulan Cepet',
  quickAnswerDesc: 'Fast response for simple questions',
  cancelRequest: 'Batal',
  library: 'Perpustakaan',
  filterAll: 'Kabeh',
  filterChat: 'Chats',
  filterReview: 'Review',
  filterDraft: 'Draft',
  filterTemplate: 'Template',
  filterForm: 'Form',
  thinking: 'Mikir...',
  thinkingProcess: 'Thinking Process',
  analyzingLegalLogic: 'Analyzing legal logic...',
  lawhelperThinking: 'Lawhelper is thinking...',
  serviceError: 'Service Error',
  uploaded: 'Uploaded',
  settingsGeneral: 'Umum',
  settingsNotifications: 'Notifications',
  settingsAppearance: 'Appearance',
  settingsProfile: 'Profile',
  settingsResponseNotifications: 'Response Notifications',
  settingsResponseNotificationsDesc: 'Get notified when AI finishes a response',
  settingsColorMode: 'Color Mode',
  settingsLight: 'Light',
  settingsDark: 'Dark',
  settingsSystem: 'System',
  about: 'Babagan',
  reviewTitle: 'Document Review',
  exitReview: 'Exit Review',
  uploadPrompt: 'Upload PDF to start review',
  uploadButton: 'Select File',
  startChatConfig: 'Type "Review this document" to start',
  reviewPlaceholder: 'Type a message or "Review this document"...',
  analyzing: 'Reviewing...',
  reviewComplete: 'Review Complete',
  issuesFound: 'Found %{count} issues',
  draftTitle: 'Legal Document Drafting',
  draftPlaceholder: 'Edit here or ask AI to generate...',
  analyzingTemplate: 'Analyzing template file %{name}...',
  templateAnalyzed: '✅ Template %{name} analyzed! Tell me how you want to modify or fill this template.',
  templateAnalysisPrompt: 'Analyze key clauses of this template',
  parsingFailed: '⚠️ Failed to parse file, but you can still describe your needs.',
  generating: 'Generating...',
  generatedSuccess: '✅ Document generated! You can view and edit in the editor.',
  drafterWelcome: 'Welcome to AI Document Assistant',
  drafterYouCan: 'You can:',
  drafterUploadTemplate: 'Upload a template for AI to analyze',
  drafterDescribeNeeds: 'Describe your document requirements',
  drafterLetAiHelp: 'Let AI help you draft contracts, agreements, etc.',
  drafterExamples: 'Examples:',
  drafterExampleRental: '"Help me draft a rental agreement"',
  drafterExampleLabor: '"Fill in the labor contract based on template"',
  drafterInputPlaceholder: 'Describe your document needs...',
  drafterThinking: 'Thinking...',
  drafterHistoryTitle: 'History',
  drafterNoHistory: 'No history yet',
  drafterNewChat: 'New Chat',
  drafterHistory: 'History',
  drafterRemoveAttachment: 'Remove attachment',
  drafterLineHeight: 'Line Height',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Export as Word (.docx)',
  drafterExportPdf: 'Export as PDF',
  drafterSave: 'Save Document',
  drafterDownload: 'Download Document',
  drafterUndo: 'Undo',
  drafterRedo: 'Redo',
  drafterBold: 'Bold',
  drafterItalic: 'Italic',
  drafterStrike: 'Strikethrough',
  drafterUnderline: 'Underline',
  drafterHighlight: 'Highlight',
  drafterLink: 'Insert Link',
  drafterAlignLeft: 'Align Left',
  drafterAlignCenter: 'Align Center',
  drafterAlignRight: 'Align Right',
  drafterAlignJustify: 'Justify',
  drafterList: 'List',
  drafterBulletList: 'Bullet List',
  drafterOrderedList: 'Ordered List',
  drafterTaskList: 'Task List',
  drafterOpenResource: 'Open Resources Panel',
  drafterStopGeneration: 'Stop generation',
  drafterAgentMode: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOn: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOff: 'Normal chat mode | Click to switch to Agent mode',
  drafterUploadAttachment: 'Upload attachment',
  drafterExit: 'Exit',
  drafterConfirm: 'Confirm',
  drafterOpenLink: 'Open link',
  drafterDeleteLink: 'Delete link',
  drafterQuote: 'Quote',
  workflowTitle: 'AI Workflow',
  workflowRunning: 'Running...',
  workflowReady: 'Ready',
  workflowCompleted: 'Completed',
  workflowStartFailed: 'Workflow start failed',
  workflowExecutionFailed: 'Workflow execution failed',
  workflowInterrupted: 'Workflow interrupted',
  workflowProcessing: 'Processing...',
  workflowStepsCompleted: 'steps completed',
  workflowStepsTotal: 'Workflow completed (%{count} steps)',
  acceptChanges: 'Accept Changes',
  rejectChanges: 'Reject Changes',
  changesAccepted: 'Changes accepted',
  changesRejected: 'Changes rejected',
  stopWorkflow: 'Stop',
  restartWorkflow: 'Restart',
  startDrafting: 'Start Drafting',
  interrupt: 'Stop',
  documentSubject: 'Document Subject *',
  documentType: 'Document Type',
  jurisdiction: 'Jurisdiction',
  specialRequirements: 'Special Requirements (optional)',
  clickStartDrafting: 'Click "Start Drafting" to begin workflow',
  docTypeContract: 'Contract',
  docTypeAgreement: 'Agreement',
  docTypeNotice: 'Notice',
  docTypeLetter: 'Letter',
  docTypePetition: 'Petition',
  docTypeWill: 'Will',
  docTypePowerOfAttorney: 'Power of Attorney',
  countryChina: 'China',
  countryUSA: 'United States',
  countryGermany: 'Germany',
  countryJapan: 'Japan',
  countryFrance: 'France',
  countryUK: 'United Kingdom',
  citationVerified: 'Verified',
  citationUnverified: 'Unverified',
  imageLoadFailed: 'Image failed to load',
  smartDocTitle: 'Asisten Dokumen Pinter',
  smartDocChatTitle: 'AI Document Assistant',
  smartDocDropPrompt: 'Drop PDF file here',
  smartDocSelectFile: 'Select File',
  smartDocOr: 'or',
  smartDocWelcomeTitle: 'Welcome to AI Document Assistant',
  smartDocWelcomeYouCan: 'You can:',
  smartDocUploadForAI: 'Upload a template for AI to analyze',
  smartDocDescribeDoc: 'Describe your document requirements',
  smartDocLetAIDraft: 'Let AI help you draft contracts, agreements, etc.',
  smartDocExamples: 'Examples:',
  smartDocExampleRental: '"Help me draft a rental agreement"',
  smartDocExampleLabor: '"Fill in the labor contract based on template"',
  smartDocInputPlaceholder: 'Describe your document needs...',
  smartDocRemoveAttachment: 'Remove attachment',
  smartDocOpenResources: 'Open Resources Panel',
  smartDocExit: 'Exit',
  reviewStartFailed: 'Review workflow start failed',
  reviewFailed: 'Review failed',
  reviewFoundIssues: 'Review complete, found %{count} issues.',
  cannotReadStream: 'Cannot read response stream',
  parseEventFailed: 'Failed to parse workflow event',
  errorPrefix: 'Kesalahan',
  unknownError: 'Unknown error',
  file: 'Berkas',
  loading: 'Ngemot...',
  localFolders: 'Local Folders',
  selectLocalFolder: 'Select Local Folder',
  reselectFolder: 'Change Folder',
  addToContext: 'Add to Chat',
  saveFile: 'Save',
  renameFile: 'Rename',
  fileSaved: 'File saved successfully',
  fileRenamed: 'File renamed to %{name}',
  browserNotSupported: 'Your browser does not support local folder access',
  noFolderSelected: 'Select a local folder to browse files',
  scanningFolder: 'Scanning folder...',
  selectFileToPreview: 'Select a file to preview',
  aiAnalyze: 'Analisis AI',
};
